// React
import React, { useEffect, useState } from 'react';
// Material-UI
import { makeStyles, Tab, Tabs } from '@material-ui/core';
// Otras libs

// Componentes
import { a11yProps, TabPanel } from 'componentes/TabPanel';
import { Seccion } from '.';
import { DTabs } from './DTabs';
import { DTab } from './DTab';
// Vistas

// Servicios

// Funciones

// Hooks

const useStyles = makeStyles({
    tabsRoot: {
        width: '100%',
        '& .MuiTabs-scroller': {
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
        },
        '& .MuiTabs-scroller::-webkit-scrollbar': {
            display: 'none',
        },
        '& .MuiTabs-scrollButtons': {
            width: 34,
        },
        '& .MuiTabs-scrollButtons.Mui-disabled': {
            opacity: 0.25,
        },
    },
});

/**
 * Especifica la función a ser ejecutada al cambiar de sección
 * @callback OnChange
 * @param {number} id - Identificador de sección seleccionada
 * @returns {void}
 */

/**
 * 
 * @typedef {Object} Props
 * @property {string} paddingBox Padding
 * @property {bool} fullWidth Establece si tab usan todo el espacio disponible
 * @property {bool} fullHeight Establece si panel usan todo el espacio disponible
 * @property {'default'|'rounded'} variant Establece variente de panel
 * @property {bool} keepMounted Si se mantenen los tabs montados
 * @property {number} idSeleccion Id seleccionado
 * @property {OnChange} onChange Evento al cambiar de sección
 */

/**
 * Sección
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const PanelSecciones = ({ 
    paddingBox = '1px',
    fullWidth = false,
    fullHeight = false,
    variant = 'default',
    keepMounted = false,
    idSeleccion = 0,
    onChange = (id) => {},
    children,
}) => {
    const classes = useStyles();

    const [tabSelecc, setTabSelecc] = useState(0);
    const secciones = React.Children.toArray(children).filter((child) => child?.type === Seccion);
    const seccionesVisibles = secciones.filter((child) => child.props.visible === undefined || child.props.visible === null || child.props.visible === true);
    
    useEffect(() => {
        setTabSelecc(idSeleccion >= 0 ? idSeleccion : 0);
    }, [idSeleccion]);

    const tabsProps = {
        value: tabSelecc,
        onChange: (event, newValue) => {
            setTabSelecc(newValue);
            onChange(newValue);
        },
        variant: 'scrollable',
        scrollButtons: 'auto',
        allowScrollButtonsMobile: true,
        className: classes.tabsRoot,
    };

    return (
        <>
            {variant === 'default' && (
                <Tabs 
                    {...tabsProps}
                    style={{ borderBottom: '2px solid #e8e8e8' }}
                >
                    {secciones.map((child, i) => {
                        if (child.props.visible === undefined || child.props.visible === null || child.props.visible === true) {
                            return (
                                <Tab 
                                    key={child.key ?? `tab-header-${i}`}
                                    value={i}
                                    icon={child.props.icon 
                                        ? React.cloneElement(child.props.icon, { style: { fontSize: '18px', margin: '0 5px 0 0' } })
                                        : undefined
                                    } 
                                    label={child.props.titulo ?? ''} 
                                    style={{ 
                                        minWidth: fullWidth ? `${(100 / Math.max(seccionesVisibles.length, 1)).toFixed()}%` : undefined,
                                        display: (child.props.visible ?? true) === true ? 'block' : 'none',
                                    }} 
                                    {...a11yProps(i)} 
                                />
                            );
                        }

                        return null;
                    })}
                </Tabs>
            )}
            {variant === 'rounded' && (
                <DTabs {...tabsProps}>
                    {secciones.map((child, i) => {
                        if (child.props.visible === undefined || child.props.visible === null || child.props.visible === true) {
                            return (
                                <DTab 
                                    key={child.key ?? `tab-rounded-${i}`}
                                    value={i}
                                    icon={child.props.icon 
                                        ? React.cloneElement(child.props.icon, { style: { fontSize: '18px', margin: '0 5px 0 0' } })
                                        : undefined
                                    } 
                                    label={child.props.titulo ?? ''} 
                                    style={{ 
                                        display: (child.props.visible ?? true) === true ? 'block' : 'none',
                                    }} 
                                    {...a11yProps(i)} 
                                />
                            );
                        }

                        return null;
                    })}
                </DTabs>
            )}
            {secciones.map((child, i) => (
                <TabPanel 
                    key={child.key ?? `tab-${i}`}
                    value={tabSelecc} 
                    index={i} 
                    paddingBox={paddingBox}
                    keepMounted={keepMounted}
                    style={{ height: !fullHeight ? '70vh' : undefined }}
                >
                    {child}
                </TabPanel>
            ))}
        </>
    );
};
